import * as Immutable from 'immutable';

import { isImage } from '../../../../../../common/elements/utils/elementTypeUtils';
import { getDescendantsViaGraph } from '../../../../../../common/elements/utils/elementGraphUtils';

import type { ImMNElement, ImMNElementMap } from '../../../../../../common/elements/elementModelTypes';

/**
 * Board images derived synchronously from the element graph, so navigation affordances can enable
 * before the worker's spatial ordering arrives.
 */
export const getProvisionalBoardImages = ({
    currentBoardId,
    elements,
    elementGraph,
}: {
    currentBoardId?: string;
    elements: ImMNElementMap;
    elementGraph: unknown;
}): Immutable.List<ImMNElement> => {
    if (!currentBoardId) return Immutable.List();

    return getDescendantsViaGraph({ elements, elementGraph, parentId: currentBoardId }).filter(isImage).toList();
};

/**
 * Gets the target image index, wrapping around the list boundaries.
 */
export const getWrappedImageNavigationIndex = ({
    currentIndex,
    imageCount,
    direction,
}: {
    currentIndex: number;
    imageCount: number;
    direction: -1 | 1;
}): number | undefined => {
    if (currentIndex < 0 || imageCount < 2) return undefined;

    return (currentIndex + direction + imageCount) % imageCount;
};

export const canNavigateImageModal = ({
    currentImageId,
    orderedImageIds,
    provisionalImageIds,
}: {
    currentImageId: string;
    orderedImageIds: readonly string[];
    provisionalImageIds: readonly string[];
}): boolean => {
    const hasOrderedNavigation = orderedImageIds.includes(currentImageId) && orderedImageIds.length >= 2;
    const hasProvisionalNavigation = provisionalImageIds.includes(currentImageId) && provisionalImageIds.length >= 2;

    return hasOrderedNavigation || hasProvisionalNavigation;
};
